import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  LanguageConfig,
  LanguageSwitcher,
} from '@zipari/shared-ds-util-navigation';

@Component({
  selector: 'mobile-language-switcher',
  templateUrl: './mobile-language-switcher.component.html',
})
export class MobileLanguageSwitcherComponent implements OnInit {
  @Input() config: LanguageSwitcher;
  @Input() activeLangKey: string;
  @Input() isMobileView = false;
  @Output() languageSwitched = new EventEmitter<LanguageConfig>();
  public activeLangKeyLabel: string;
  public openLanguageModal = false;
  public languageControl;
  public languageForm: UntypedFormGroup = new UntypedFormGroup({});
  public selectedLanguage = new UntypedFormControl(null);
  public valueKey = 'key';
  public displayProperty = 'label';

  ngOnInit() {
    this.setLanguageOptions();
  }

  private setLanguageOptions(): void {
    const languageOptions = this.config?.listOfLanguages?.languages.map(
      (language) => {
        if (language.key === this.activeLangKey) {
          this.activeLangKeyLabel = language.label;
        }

        return {
          label: language.label,
          value: language.key,
        };
      },
    );

    this.languageControl = [
      {
        prop: 'selectedLanguage',
        type: 'radio',
        label: null,
        alignment: 'justified',
        default: this.activeLangKey,
        options: languageOptions,
      },
    ];
  }

  public get languagesSwitcherEnabled(): boolean {
    const langList = this.config?.listOfLanguages?.languages;
    const isEnabled = this.config?.enabled;

    return isEnabled && langList?.length > 1;
  }

  public handleLanguageChange(): void {
    const selectedLanguage = this.config.listOfLanguages.languages.find(
      (language) =>
        language.key === this.languageForm.get('selectedLanguage').value,
    );

    this.languageSwitched.emit(selectedLanguage);
  }
}
